import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cart'; // Import the cart slice
import storage from 'redux-persist/lib/storage'; // Use localStorage
import { persistReducer, persistStore } from 'redux-persist';

const persistConfig = {
  key: 'cart',
  storage,
};

const persistedCartReducer = persistReducer(persistConfig, cartReducer);

const store = configureStore({
  reducer: {
    cart: persistedCartReducer,
  },
});

export const persistor = persistStore(store); // Ensure persistor is correctly exported
export default store;
